var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19305 10.5857L8.77971 7.99901L6.19305 5.41234C5.93305 5.15234 5.93305 4.73234 6.19305 4.47234C6.45305 4.21234 6.87305 4.21234 7.13305 4.47234L10.193 7.53234C10.453 7.79234 10.453 8.21234 10.193 8.47234L7.13305 11.5323C6.87305 11.7923 6.45305 11.7923 6.19305 11.5323C5.93971 11.2723 5.93305 10.8457 6.19305 10.5857Z",
    fill: "url(#paint0_linear_11791_8232)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11791_8232",
    x1: 5.99805,
    y1: 4.27734,
    x2: 10.996,
    y2: 4.70973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientArrowRight);
export default __webpack_public_path__ + "static/media/gradientArrowRight.c439b944d5a8cfcddb47d00f8ee0ddbb.svg";
export { ForwardRef as ReactComponent };